import type { AuctionItemEntity } from '~/apiClient';

export interface AuctionItemEntityWithCurrentPrice extends Omit<AuctionItemEntity, 'currentPrice'> {
    currentPrice: number;
}

export function isAuctionItemEntityWithCurrentPrince(entity: AuctionItemEntity): entity is AuctionItemEntityWithCurrentPrice {
    return typeof entity.currentPrice === 'number';
}
